export interface ShortenIdOptions {
  prefix?: number;
  suffix?: number;
}

export const shortenId = (
  id: string | null | undefined,
  options?: ShortenIdOptions,
): string => {
  if (!id) return '—';
  const prefix = options?.prefix ?? 6;
  const suffix = options?.suffix ?? 4;
  if (id.length <= prefix + suffix + 1) return id;
  return `${id.slice(0, prefix)}…${id.slice(-suffix)}`;
};
